export const CONTINUE_CHAT = 'CONTINUE_CHAT';
export const SEND_INITIAL_MESSAGES_TO_CLIENT = 'SEND_INITIAL_MESSAGES_TO_CLIENT';
export const CHAT_NOT_EXISTS = 'CHAT_NOT_EXISTS';
export const UPDATE_CHAT_MAPPING = 'UPDATE_CHAT_MAPPING';
export const NOTIFY_SUPPORT_OPERATOR_FOR_HEARTBEAT = 'NOTIFY_SUPPORT_OPERATOR_FOR_HEARTBEAT';
export const SUPPORT_OPERATOR_CHANGED_ONLINE_STATUS = 'SUPPORT_OPERATOR_CHANGED_ONLINE_STATUS';
export const SUPPORT_OPERATOR_IS_TYPING = 'SUPPORT_OPERATOR_IS_TYPING';
export const USER_TOGGLED_SOUND = 'USER_TOGGLED_SOUND';
export const USER_SUBMITTED_CHAT_RATING = 'USER_SUBMITTED_CHAT_RATING';

export const continueChat = ({ requestId, status, currentOperatorId, messages, operators, languages }) => ({
  type: CONTINUE_CHAT,
  payload: {
    requestId,
    status,
    currentOperatorId,
    messages,
    operators,
    languages
  }
});

export const sendInitialMessagesToClient = ({
  userId,
  currentOperatorId,
  messages,
  operators,
  languages,
  auto_translated
}) => ({
  type: SEND_INITIAL_MESSAGES_TO_CLIENT,
  payload: {
    userId,
    currentOperatorId,
    messages,
    operators,
    languages,
    auto_translated
  }
});

export const chatNotExists = ({ visitorId, userId, reason }) => ({
  type: CHAT_NOT_EXISTS,
  payload: {
    visitorId,
    userId,
    reason
  }
});

export const updateChatMapping = ({ visitorId, requestId, operatorId }) => ({
  type: UPDATE_CHAT_MAPPING,
  payload: {
    visitor_id: visitorId,
    request_id: requestId,
    operator_id: operatorId
  }
});

export const notifySupportOperatorForHeartBeat = ({ operatorId, visitorId, event }) => ({
  type: NOTIFY_SUPPORT_OPERATOR_FOR_HEARTBEAT,
  payload: {
    operatorId,
    visitorId,
    event
  }
});

// added just for reference
// sg-chat dispatches it without importing it, cause it is in different repo
export const supportOperatorChangedOnlineStatus = () => ({
  type: SUPPORT_OPERATOR_CHANGED_ONLINE_STATUS,
  payload: {}
});

export const userToggledSound = ({ isSoundOn }) => ({
  type: USER_TOGGLED_SOUND,
  payload: {
    isSoundOn
  }
});

export const userSubmittedChatRating = () => ({
  type: USER_SUBMITTED_CHAT_RATING,
  payload: {}
});
